import { Box, Typography } from '@mui/material'
import { Whale } from 'store/reporting/benchmark/types'

const Label = ({ children }: { children: any }) => (
  <Box component="span" fontWeight="bold">
    {children}
  </Box>
)

type Props = {
  whale: Whale
}

export default function WhaleElement({ whale }: Props) {
  return (
    <>
      <Typography>
        <Label>Domain Name (dn):</Label> {whale.dn}
      </Typography>
      <Typography>
        <Label>Alias Names (an):</Label> {whale.an.join(', ')}
      </Typography>
      <Typography>
        <Label>Tiker (tk):</Label> {whale.tk.join(', ')}
      </Typography>
      <Typography>
        <Label>Patent Count (pc):</Label> {whale.pc}
      </Typography>
      <Typography>
        <Label>Categories in (ci):</Label> {whale.ci}
      </Typography>
      <Typography>
        <Label>Patents in (pi):</Label> {whale.pi}
      </Typography>
      <Typography>
        <Label>Patents out (po):</Label> {whale.po}
      </Typography>
      <Typography>
        <Label>PIP:</Label> {whale.pip}
      </Typography>
      <Typography>
        <Label>Categories by year (cby):</Label>{' '}
        {Object.entries(whale.cby)
          .map(([key, value]) => `${key}: ${value}`)
          .join(', ')}
      </Typography>
      <Typography>
        <Label>Categories by quarter (cbq):</Label>{' '}
        {Object.entries(whale.cbq)
          .map(([key, value]) => `${key}: ${value}`)
          .join(', ')}
      </Typography>
      <Typography>
        <Label>CBI:</Label>{' '}
        {Object.entries(whale.cbi)
          .map(([key, value]) => `${key}: ${value}`)
          .join(', ')}
      </Typography>
      <Typography>
        <Label>CBIY:</Label>{' '}
        {Object.entries(whale.cbiy)
          .map(
            ([key, value]) =>
              `${key}: {${Object.entries(value)
                .map(([k, v]) => `${k}: ${v}`)
                .join(', ')}}`,
          )
          .join(', ')}
      </Typography>
      <Typography>
        <Label>CBIQ:</Label>{' '}
        {Object.entries(whale.cbiq)
          .map(
            ([key, value]) =>
              `${key}: {${Object.entries(value)
                .map(([k, v]) => `${k}: ${v}`)
                .join(', ')}}`,
          )
          .join(', ')}
      </Typography>
    </>
  )
}
